import Types from "./types";
import { STEP_NAMES } from "../../../utils/funnel/steps.desktop";
import { LeadServiceJava} from "../../../service/lead-service-java-api";
import queryString from "querystring";
import { CarService } from "../../../service/car-service";
import { VehicleService } from "../../../service/vehicle-service";

const setStep = ({ currentStep, tabs }) => {
    return {
        type: Types.SET_CURRENT_STEP,
        currentStep,
        tabs
    };
};

const setStepLandingLead = ({ currentStep, tabs }) => {
    return {
        type: Types.SET_CURRENT_STEP,
        currentStep,
        tabs
    };
};

const setBrand = ({ brand }) => ({
    type: Types.SET_BRAND,
    brand
});

const setModel = ({ model }) => ({
    type: Types.SET_MODEL,
    model
});

const setYear = ({ year }) => ({
    type: Types.SET_YEAR,
    year
});

const setFuelType = ({ fuelType }) => ({
    type: Types.SET_FUEL_TYPE,
    fuelType
});

const setTransmissionType = ({ transmission }) => ({
    type: Types.SET_TRANSMISSION_TYPE,
    transmission
});

const setVariant = ({ variant }) => ({
    type: Types.SET_VARIANT,
    variant
});

const setToken = (token) => ({
    type: Types.SET_TOKEN,
    token
});

const setRegistrationState = ({ registrationState }) => ({
    type: Types.SET_REGISTRATION_STATE,
    registrationState
});

const setRTO = ({ rto }) => ({
    type: Types.SET_RTO,
    rto
});

// const setBranch = ({ branch, stepper, tabs, tabData }) => ({
//     type: Types.SET_BRANCH,
//     branch,
//     stepper,
//     tabs,
//     tabData
// });

const setKilometerDriven = ({ kilometersDriven }) => ({
    type: Types.SET_KILOMETERS_DRIVEN,
    kilometersDriven
});

const makeLeadSuccess = (data) => ({
    type: Types.MAKE_LEAD_SUCCESS,
    data
});

const makeLeadFailure = (data) => ({
    type: Types.MAKE_LEAD_FAILURE,
    data
});

// const showProceedButton = () => ({
//     type: Types.SHOW_PROCEED_BUTTON
// });

const activateLastStep = (flag) => ({
    type: Types.ACTIVATE_LAST_STEP,
    flag
});

const makeLeadInit = () => ({
    type: Types.MAKE_LEAD
});

const makeSellOnlineLead = (query, payload) => dispatch => {
    dispatch(makeLeadInit());
    const stringifiedQuery = queryString.stringify(query);
    return new Promise((resolve, reject) => {
        LeadServiceJava.createLead(stringifiedQuery, payload)
            .then(response => {
                resolve(response.data.detail);
                dispatch(makeLeadSuccess(response.data.detail));
            })
            .catch(error => {
                reject(error);
                dispatch(makeLeadFailure(error));
            });
    });
};

const updateSellOnlineLead = (query, params) => dispatch => {
    const stringifiedQuery = queryString.stringify(query);
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateLead(stringifiedQuery, params).then(response => {
            resolve(response.data.detail);
            dispatch(makeLeadSuccess(response.data.detail));
        }).catch(error => {
            reject(error);
            dispatch(makeLeadFailure(error));
        });
    });
};

const makeLead = (query, payload) => dispatch => {
    dispatch(makeLeadInit());
    const stringifiedQuery = queryString.stringify(query);
    return new Promise((resolve, reject) => {
        LeadServiceJava.createLead(stringifiedQuery, payload)
            .then(response => {
                resolve(response.data.detail);
                dispatch(makeLeadSuccess(response.data.detail));
            })
            .catch(error => {
                reject(error);
                dispatch(makeLeadFailure(error));
            });
    });
};

const updateLead = (query, params, updateReducer = true) => dispatch => {
    const stringifiedQuery = queryString.stringify(query);
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateLead(stringifiedQuery, params).then(response => {
            resolve(response.data.detail);
            if (updateReducer) {
                dispatch(makeLeadSuccess(response.data.detail));
            }
        }).catch(error => {
            reject(error);
            dispatch(makeLeadFailure(error));
        });
    });
};

const mergeLeadData = (response) => ({
    type: Types.MERGE_LEAD_DATA,
    data: response
});
const setDataLandingLead = (type, data) => dispatch => {
    switch (type) {
    case STEP_NAMES.Brand:
        dispatch(setBrand({
            [STEP_NAMES.Brand]: data
        }));
        break;
    case STEP_NAMES.Model:
        dispatch(setModel({
            [STEP_NAMES.Model]: data
        }));
        break;
    case STEP_NAMES.Year:
        dispatch(setYear({ [STEP_NAMES.Year]: data }));
        break;
    case STEP_NAMES.FuelType:
        dispatch(setFuelType({
            [STEP_NAMES.FuelType]: data
        }));
        break;
    case STEP_NAMES.Transmission:
        dispatch(setTransmissionType({
            [STEP_NAMES.Transmission]: data
        }));
        break;
    case STEP_NAMES.Variant:
        dispatch(setVariant({ [STEP_NAMES.Variant]: data }));
        break;
    case STEP_NAMES.State:
        dispatch(setRegistrationState({ [STEP_NAMES.State]: data }));
        break;
    case STEP_NAMES.RTO:
        dispatch(setRTO({ [STEP_NAMES.RTO]: data }));
        break;
    case STEP_NAMES.KilometerDriven:
        dispatch(setKilometerDriven({ [STEP_NAMES.KilometerDriven]: data }));
        break;
        // case STEP_NAMES.Branch:
        //     dispatch(setBranch({
        //         [STEP_NAMES.Branch]: data,
        //         stepper,
        //         tabs,
        //         tabData
        //     }));
        //     break;
    }
};
const setData = (type, data) => dispatch => {
    switch (type) {
    case STEP_NAMES.Brand:
        dispatch(setBrand({
            [STEP_NAMES.Brand]: data
        }));
        break;
    case STEP_NAMES.Model:
        dispatch(setModel({
            [STEP_NAMES.Model]: data
        }));
        break;
    case STEP_NAMES.Year:
        dispatch(setYear({ [STEP_NAMES.Year]: data }));
        break;
    case STEP_NAMES.FuelType:
        dispatch(setFuelType({
            [STEP_NAMES.FuelType]: data
        }));
        break;
    case STEP_NAMES.Transmission:
        dispatch(setTransmissionType({
            [STEP_NAMES.Transmission]: data
        }));
        break;
    case STEP_NAMES.Variant:
        dispatch(setVariant({ [STEP_NAMES.Variant]: data }));
        break;
    case STEP_NAMES.State:
        dispatch(setRegistrationState({ [STEP_NAMES.State]: data }));
        break;
    case STEP_NAMES.RTO:
        dispatch(setRTO({ [STEP_NAMES.RTO]: data }));
        break;
    case STEP_NAMES.KilometerDriven:
        dispatch(setKilometerDriven({ [STEP_NAMES.KilometerDriven]: data }));
        break;
        // case STEP_NAMES.Branch:
        //     dispatch(setBranch({
        //         [STEP_NAMES.Branch]: data,
        //         stepper,
        //         tabs,
        //         tabData
        //     }));
        //     break;
    }
};

// const resetLeadFormData = () => ({
//     type: Types.RESET_LEAD_FORM_DATA
// });

// const setFlowName = (flowName) => ({ type: Types.SET_FLOW_NAME, flowName });

// const updateCTALocation = (ctaLocation) => ({
//     type: Types.UPDATE_CTA_LOCATION,
//     ctaLocation
// });

const setCurrentQuestionIndex = (index) => ({
    type: Types.SET_CURRENT_QUESTION_INDEX,
    index
});

const setAnsweredQuestions = ({ key, value }) => ({
    type: Types.STORE_ANSWERED_QUESTION,
    key,
    value
});

const updateQuestionsArray = (questionArray) => ({
    type: Types.SET_QUESTIONS_ARRAY,
    questionArray
});

const setSelectedDate = (date) => ({
    type: Types.SET_SELECTED_DATE,
    date
});

const setSelectedTime = (time) => ({
    type: Types.SET_SELECTED_TIME,
    time
});

const setLocationName = (location) => ({
    type: Types.SET_LOCATION_NAME,
    location
});

const setBasicDetailCompleteWithLocation = (data) => ({
    type: Types.SET_BASIC_DETAILS_COMPLETE,
    data
});

const resetQuestions = () => ({
    type: Types.RESET_QUESTIONS
});
const getSellOnlineQuestion = (payload) => () => {
    return new Promise((resolve, reject) => {
        VehicleService.getSellOnlineQuestion(payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

const fetchModelData = (makeId) => () => {
    return new Promise((resolve, reject) => {
        CarService.fetchModels(makeId)
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
    });
};
const resetSellOnlineLeadData = (response) => ({
    type: Types.RESET_SELLONLINE_LEAD_FORM_DATA,
    data: response
});

// eslint-disable-next-line no-unused-vars
const updateLeadWithGsDeny = (token, params) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateLeadWithGsDeny(token, params).then(response => {
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchFAQ = (params) => () => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchFaqs(params)
            .then(response => resolve(response.data.detail))
            .catch(error => reject(error));
    });
};

export {
    fetchFAQ,
    setBasicDetailCompleteWithLocation,
    setStepLandingLead,
    setDataLandingLead,
    makeSellOnlineLead,
    updateSellOnlineLead,
    setData,
    setStep,
    // setKilometerDriven,
    makeLead,
    // showProceedButton,
    activateLastStep,
    updateLead,
    mergeLeadData,
    setCurrentQuestionIndex,
    setAnsweredQuestions,
    updateQuestionsArray,
    setSelectedDate,
    setSelectedTime,
    setLocationName,
    setToken,
    getSellOnlineQuestion,
    fetchModelData,
    resetQuestions,
    resetSellOnlineLeadData,
    updateLeadWithGsDeny
    // resetLeadFormData,
    // setFlowName,
    // setRTO,
    // updateCTALocation,
    // updateProceedCTAStatus,
    // setFuelType,
    // setTransmissionType,
    // setVariantActiveScreen
};
